import React from "react";
import { styled } from "@mui/material";
import {
  Box,
  Button,
  Typography,
  Paper,
  TextField,
} from "mpulse-design-system";
import { sendResetLink } from "../../services/PasswordReset/PasswordResetServices";
import BackToSignInButton from "../BackToSignInButton/BackToSignInButton";

import { isEmail } from "validator/validator";
import constants from "../../constants";

export const PasswordResetLinkRequest = () => {
  const [email, setEmail] = React.useState("");
  const [emailIsValid, setEmailIsValid] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [requestSent, setRequestSent] = React.useState(false);

  const sendPasswordReset = () => {
    sendResetLink(email)
      .then((res) => {
        setRequestSent(true);
      })
      .catch((e) => {
        setRequestSent(true);
      });
  };

  const handleErrorMsg = (e) => {
    !isEmail(e.target.value)
      ? setErrorMessage(constants.resetPassword.errors.emailError)
      : setErrorMessage(null);
  };

  const RequestSent = () => (
    <>
      <Typography data-testid="request-sent-message">
        If the User ID exists, an email has been sent with a link to reset your
        password.
      </Typography>
    </>
  );

  const handleInputChange = (e) => {
    setEmail(e.target.value);
    isEmail(e.target.value) ? setEmailIsValid(true) : setEmailIsValid(false);
  };

  return (
    <StyledPaper>
      <StyledBox>
        {/* title */}
        <Typography variant="h1" color="textPrimary">
          Reset Password
        </Typography>
        {/* variable form */}
        {requestSent ? (
          <RequestSent />
        ) : (
          <>
            <Typography>
              Enter your email address to receive a password reset link.
            </Typography>
            <StyledTextField
              id="email"
              data-testid="email-input"
              color="secondary"
              defaultValue={email}
              type="text"
              label="email"
              onChange={handleInputChange}
              helperText={errorMessage}
              onBlur={handleErrorMsg}
              error={Boolean(errorMessage)}
            />
            <Button
              data-testid="send-button"
              sx={{
                width: "175px",
                alignSelf: "flex-end",
              }}
              type="submit"
              variant="contained"
              color="secondary"
              onClick={sendPasswordReset}
              disabled={!emailIsValid}
            >
              Send Reset Link
            </Button>
          </>
        )}
        {/* link */}
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ alignSelf: "center" }}>
          <BackToSignInButton />
        </Box>
      </StyledBox>
    </StyledPaper>
  );
};

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: "1",
  "& > *": {
    marginBottom: `${theme.spacing(4)} !important`,
  },
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(5),
  height: "525px",
  width: "325px",
  position: "relative",
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  overflow: "hidden",
  label: {
    color: "${theme.palette.text.disabled} !important",
  },
  "input::-webkit-caps-lock-indicator": {
    position: "absolute",
    left: "-15px",
  },
}));
